import axios from "axios";

export default {
    sendReferralInvite: async (payload) => {
        const { data } = await axios.post(`/referral`, payload)
        return data
    },
    getReferralStatistics: async () => {
        const { data } = await axios.get('/referral')

        return data
    }
}
